import Icon from '../components/Icon.vue'

Icon.register({
  kaaba: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M554.1 83.5c13.1 4.4 21.9 16.6 21.9 30.4v49l-265-79.5c-15.1-4.5-31-4.5-46 0l-265 79.5v-49c0-12.7 9.8-26.3 21.9-30.4l235.8-78.6c8.2-2.7 21.8-4.9 30.4-4.9s22.2 2.2 30.4 4.9zM274.2 114c9-2.7 18.5-2.7 27.6 0l274.2 82.3v228.4c0 15-10.4 28-25.1 31.2l-242.1 53.8c-5.7 1.3-15 2.3-20.8 2.3s-15.1-1-20.8-2.3l-242.1-53.8c-14.6-3.3-25.1-16.2-25.1-31.2v-228.4zM128 230.1v-16.6c0-5.3-5-9.1-10.1-7.7l-80 21.8c-3.5 1-5.9 4.1-5.9 7.7v16.6c0 5.3 5 9.1 10.1 7.7l80-21.8c3.5-1 5.9-4.1 5.9-7.7zM272 190.8v-16.6c0-5.3-5-9.1-10.1-7.7l-96 26.2c-3.5 1-5.9 4.1-5.9 7.7v16.6c0 5.3 5 9.1 10.1 7.7l96-26.2c3.5-1 5.9-4.1 5.9-7.7zM448 213.5v16.6 0c0 3.4 2.6 6.8 5.9 7.7l80 21.8c5.1 1.4 10.1-2.4 10.1-7.7v-16.6c0-3.6-2.4-6.8-5.9-7.7l-80-21.8c-5.1-1.4-10.1 2.4-10.1 7.7zM304 174.3v16.6 0c0 3.4 2.6 6.8 5.9 7.7l96 26.2c5.1 1.4 10.1-2.4 10.1-7.7v-16.6c0-3.6-2.4-6.8-5.9-7.7l-96-26.2c-5.1-1.4-10.1 2.4-10.1 7.7z'
      }
    ]
  }
})
